/**
 * Endereço público do Metria — o que vai dentro do QR da etiqueta.
 *
 * POR QUE NÃO `window.location.origin`. Na web ele é exatamente o certo. No
 * app, porém, a origem é `capacitor://localhost` — uma etiqueta impressa pelo
 * aplicativo sairia com um QR apontando para um endereço que **nenhuma câmera
 * consegue abrir**. E o defeito só apareceria no papel, depois de impresso,
 * com a etiqueta já colada na embalagem.
 *
 * Papel impresso é permanente: o endereço aqui precisa ser o público e estável.
 */

import { isNative } from './native';

const PADRAO = 'https://metria.demiplie.com.br';

/**
 * @returns {string} origem sem barra no fim (ex.: https://metria.demiplie.com.br)
 */
export function baseWeb() {
  // Configurável para o app de staging apontar para o site de staging.
  const configurada = process.env.REACT_APP_WEB_URL;
  if (configurada) return configurada.replace(/\/$/, '');

  if (!isNative() && typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  return PADRAO;
}

/** URL que a etiqueta imprime no QR. */
export function urlDaEtiqueta(codigo) {
  return `${baseWeb()}/e/${codigo}`;
}

// Alfabeto do codigo, espelhando backend/validade.py: sem vogais e sem os
// pares que se erra lendo do papel (O/0, I/1).
const FORMATO_CODIGO = /^[BCDFGHJKLMNPQRSTVWXYZ23456789]{8}$/i;

/**
 * Extrai o codigo da etiqueta do que a camera leu.
 *
 * Aceita de proposito quatro formas, porque nao controlamos quem le nem de
 * onde o papel veio:
 *   - URL completa impressa pelo app ou pela web
 *   - a mesma URL com querystring (leitores de QR gostam de acrescentar coisa)
 *   - o codigo nu, digitado a mao quando o QR desbotou
 *   - qualquer uma delas em minusculas
 *
 * NAO checa o host: uma etiqueta impressa em staging aponta para o dominio de
 * staging, e uma impressa antes de uma troca de dominio continuaria valendo.
 * O que identifica e o caminho /e/<codigo> e o formato do codigo.
 *
 * @returns {string|null} codigo em maiusculas, ou null se nao for etiqueta
 */
export function codigoDeQr(valor) {
  const bruto = String(valor || '').trim();
  if (!bruto) return null;

  if (FORMATO_CODIGO.test(bruto)) return bruto.toUpperCase();

  const casou = bruto.match(/\/e\/([^/?#\s]+)/i);
  if (casou && FORMATO_CODIGO.test(casou[1])) return casou[1].toUpperCase();

  return null;
}
